module.exports = __webpack_public_path__ + "img/utb-logo.ac6f039c.svg";